import { useFormik } from "formik";
import { useKPI } from "providers/KPIProvider";
import { useState } from "react";
import { useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import { extractNumbers } from "utils/app.util";
import { numberFormatter, parseNumberString } from "utils/number.util";

const KPIMetricForm = forwardRef(
  (
    { kpi, metrics, selectedMonth, validMonths, onClose, setSubmitLoading },
    ref
  ) => {
    const [toShow, setToShow] = useState(false);
    // console.log(kpi);
    useEffect(() => {
      const itemDate = new Date(kpi.startDate);
      const itemEndDate = new Date(kpi.endDate);
      const year = Number(selectedMonth.slice(0, 4));
      const month = Number(selectedMonth.slice(-2));
      console.log(selectedMonth);
      const currentDate = new Date();

      const check =
        itemDate.getFullYear() + itemDate.getMonth() / 100 <=
          year + (month - 1) / 100 &&
        year + (month - 1) / 100 <=
          itemEndDate.getFullYear() + itemEndDate.getMonth() / 100;

      console.log(kpi, check, month - 1, itemDate.getMonth());

      setToShow(check);
    }, [selectedMonth]);

    const [initialValues, setInitialValues] = useState(
      validMonths.length === 2
        ? {
            currentMonthMetric: "",
            previousMonthMetric: "",
          }
        : { currentMonthMetric: "" }
    );
    const submitRef = useRef(null);
    const { editKPIMetricRecords } = useKPI();
    const { setValues, ...formik } = useFormik({
      initialValues: initialValues,
      onSubmit: (values) => {
        values.previousMonthMetric = Number.parseInt(
          parseNumberString(values.previousMonthMetric || "0")
        );
        values.currentMonthMetric = Number.parseInt(
          parseNumberString(values.currentMonthMetric || "0")
        );

        if (validMonths.length === 2) {
          editKPIMetricRecords(kpi._id, {
            [validMonths[0].value]: values.previousMonthMetric,
            [validMonths[1].value]: values.currentMonthMetric,
          })
            .then(() => {
              onClose();
            })
            .catch((ex) => {
              console.log(ex);
            })
            .finally(() => {
              setSubmitLoading(false);
            });
        } else if (validMonths.length === 1) {
          editKPIMetricRecords(kpi._id, {
            [validMonths[0].value]: values.currentMonthMetric,
          })
            .then(() => {
              onClose();
            })
            .catch((ex) => {
              console.log(ex);
            })
            .finally(() => {
              setSubmitLoading(false);
            });
        }
      },
    });

    useImperativeHandle(
      ref,
      () => ({
        submitForm() {
          submitRef.current.click();
        },
      }),
      []
    );

    useEffect(() => {
      if (validMonths.length === 2) {
        const previousMonthMetric =
          metrics.find((metric) => metric.monthName === validMonths[0].value)
            ?.metric || "";
        const currentMonthMetric =
          metrics.find((metric) => metric.monthName === validMonths[1].value)
            ?.metric || "";

        setValues({
          previousMonthMetric: previousMonthMetric
            ? numberFormatter.format(previousMonthMetric)
            : previousMonthMetric,
          currentMonthMetric: currentMonthMetric
            ? numberFormatter.format(currentMonthMetric)
            : currentMonthMetric,
        });
      } else if (validMonths.length === 1) {
        const currentMonthMetric =
          metrics.find((metric) => metric.monthName === validMonths[0]?.value)
            ?.metric || "";

        setValues({
          currentMonthMetric: currentMonthMetric
            ? numberFormatter.format(currentMonthMetric)
            : currentMonthMetric,
        });
      }
    }, [metrics, validMonths, setValues]);

    if (!kpi._id || !metrics) {
      return null;
    }
    if (!toShow) {
      return null;
    }

    return (
      <form onSubmit={formik.handleSubmit}>
        <div className="px-6 py-3">
          <input
            type="text"
            placeholder={`KPI Name`}
            value={kpi.name}
            readOnly
            className="px-3 py-2 bg-white border border-[#D9D9D9] rounded-[6px] text-[14px] focus:outline-none focus:ring-1 focus:ring-[#55C880]"
          />
          {validMonths.length === 2 ? (
            <div className="">
              <input
                id="previousMonthMetric"
                name="previousMonthMetric"
                type="text"
                inputMode="numeric"
                placeholder="Enter target value"
                className="px-3 py-2 bg-white border border-[#D9D9D9] rounded-[6px] text-[14px] focus:outline-none focus:ring-1 focus:ring-[#55C880]"
                value={formik.values.previousMonthMetric}
                onChange={(e) =>
                  formik.setFieldValue(
                    "previousMonthMetric",
                    numberFormatter.format(extractNumbers(e.target?.value))
                  )
                }
                onBlur={formik.handleBlur}
                hidden={selectedMonth !== validMonths[0].value}
              />
              <input
                id="currentMonthMetric"
                name="currentMonthMetric"
                type="text"
                inputMode="numeric"
                placeholder="Enter target value"
                className="px-3 py-2 bg-white border border-[#D9D9D9] rounded-[6px] text-[14px] focus:outline-none focus:ring-1 focus:ring-[#55C880]"
                value={formik.values.currentMonthMetric}
                onChange={(e) =>
                  formik.setFieldValue(
                    "currentMonthMetric",
                    numberFormatter.format(extractNumbers(e.target?.value))
                  )
                }
                onBlur={formik.handleBlur}
                hidden={selectedMonth !== validMonths[1].value}
              />
            </div>
          ) : (
            <input
              id="currentMonthMetric"
              name="currentMonthMetric"
              type="text"
              inputMode="numeric"
              placeholder="Enter target value"
              className="px-3 py-2 bg-white border border-[#D9D9D9] rounded-[6px] text-[14px] focus:outline-none focus:ring-1 focus:ring-[#55C880]"
              value={formik.values.currentMonthMetric}
              onChange={(e) =>
                formik.setFieldValue(
                  "currentMonthMetric",
                  numberFormatter.format(extractNumbers(e.target?.value))
                )
              }
              onBlur={formik.handleBlur}
              hidden={selectedMonth !== validMonths[0]?.value}
            />
          )}
        </div>
        <button type="submit" ref={submitRef} hidden></button>
      </form>
    );
  }
);

export default KPIMetricForm;
